import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import RecentSearchUI from '../../../../stories/components/hotels/HomePage/RecentSearchUI/RecentSearchUI';

import {useNavigateForSearchWidget} from '../../../hooks/useNavigateForSearchWidget';

import {getRecentSearch} from '@stencil/hotels-utils/src/recent-search-util';
import {IUpdate_Query, UPDATE_QUERY} from '@stencil/hotels-common-reducer/src/types';
import {updateSelectedProperty} from '@stencil/hotels-common-reducer/src/actions';
import addDays from '@stencil/date-utils/src/addDays';
import {appConfig} from '@stencil/hotels-config';
import {convertRoomStringToReadable} from '../../../utils/room-string-utils';
import {eventMiddlewareForFE} from '../../../utils/common-utils';
import {pushga} from 'ga-utils';
import {HomePageGAEvents} from '../../../config/ga-config';

const RecentSearch = () => {
  const {defaultCheckinOffset, defaultCheckoutOffset} = appConfig;
  const dispatch = useDispatch();

  let goHomeSearchesList = getRecentSearch();

  if (!goHomeSearchesList) return null;

  const {onSearch} = useNavigateForSearchWidget();

  const updateQueryCaller = useCallback((actionData: IUpdate_Query['actionData']) => {
    return dispatch({type: UPDATE_QUERY, actionData});
  }, []);

  const updateSelectedPropertyCaller = useCallback(
    changes => {
      return dispatch(
        updateSelectedProperty({
          payload: {
            propertyId: changes._id,
            propertyName: changes.n,
          },
        }),
      );
    },
    [dispatch],
  );

  const sliderClicksGAHandler = index => {
    pushga({
      eventCategory: HomePageGAEvents.sliderClicks.category,
      eventAction: HomePageGAEvents.sliderClicks.action.recentSearchSliderClicked,
      eventLabel: index,
    });
  };

  const homePageClicksGAHandler = val => {
    pushga({
      eventCategory: HomePageGAEvents.hotelHomePageLocationClicks.category,
      eventAction: HomePageGAEvents.hotelHomePageLocationClicks.action.recentSearchesClicked,
      eventLabel: val,
    });
  };

  return (
    <RecentSearchUI
      onSearch={onSearch}
      updateQueryCaller={updateQueryCaller}
      updateSelectedPropertyCaller={updateSelectedPropertyCaller}
      goHomeSearchesList={goHomeSearchesList}
      addDays={addDays}
      defaultCheckinOffset={defaultCheckinOffset}
      defaultCheckoutOffset={defaultCheckoutOffset}
      convertRoomStringToReadable={convertRoomStringToReadable}
      eventMiddlewareForFE={eventMiddlewareForFE}
      sliderClicksGAHandler={sliderClicksGAHandler}
      homePageClicksGAHandler={homePageClicksGAHandler}
    />
  );
};

export default RecentSearch;
